import React, { useState } from "react";
import CustomDropdown from "../../../dropdown/CustomDropdown";
import { retentionRate } from "../adminData";
import GreenChartSvg from "../svgIcons/GreenChartSvg";
import RedChartSvg from "../svgIcons/RedChartSvg";
import LineChart from "./charts/LineChart";
import BarChartMedium from "./charts/BarChartMedium";
import BarChartThin from "./charts/BarChartThin";

const MetricsData = ({ metricsData }) => {
  const [metricsState , setMatricesState]=useState("retention_rate")

  const revenueStatistics = { "labels" : [
    "Jan",
    "Feb",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
],
percentage:true,
yearlyBasedStatistics : [{
  color:"#16CA7C",
  dataSet:[
    10,
    20,
    30,
    40,
    50,
    70,
    80,
    3,
    2,
    1,
    100,
    99,
    10,
    10
  ],
  year:"2024"
},
{
  color:"#BEC2C5",
  dataSet:[
    4,
    3,
    2,
    1,
    10,
    11,
    22,
    33,
    44,
    100,
    55,
    66,
    77,
    88
  ],
  year:"2025"
}
]
}


const netRevenueStatistics = 
{ "labels" : [
  "Jan",
  "Feb",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
],
percentage:true,
yearlyBasedStatistics : [{
color:"#16CA7C",
dataSet:[
  0,
  0,
  0,
  0,
  10,
  20,
  30,
  40,
  50,
  60,
  70,
  99,
  10,
  10
],
year:"2024"
},
{
color:"#BEC2C5",
dataSet:[
  4,
  3,
  2,
  1,
  10,
  11,
  22,
  33,
  44,
  100,
  55,
  66,
  77,
  88
],
year:"2025"
}
]
}

const accountCancelledStatistics = 

{ "labels" : [
  "Jan",
  "Feb",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
],
percentage:true,
yearlyBasedStatistics : [{
color:"#16CA7C",
dataSet:[
  1000,
  2000,
  1000,
  400,
  300,
  20,
  30,
  40,
  50,
  60,
  70,
  99,
  10,
  10
],
year:"2024"
},
{
color:"#BEC2C5",
dataSet:[
  4,
  3,
  2,
  1,
  10,
  11,
  22,
  33,
  44,
  100,
  55,
  66,
  77,
  88
],
year:"2025"
}
]
}
  return (
    <>
      <div className="p-5 border border-[#EBEFF3] rounded-md bg-white mb-6">
        <h3 className="text-xl leading-[160%] font-bold text-[#04091E] mb-8">
          Metrics
        </h3>
        <div className="grid grid-cols-12 gap-5 items-center">
          <div className="col-span-12 xl:col-span-4">
            <div className="bg-[#FAFAFB] rounded-md py-[30px] px-5 md:px-6 border border-[#EBEFF3]">
            <div className="col-span-12 sm:col-span-6 md:py-[20px]  border rounded-md items-center justify-between cursor-pointer bg-white mb-[10px]" style={{border:`${metricsState === "retention_rate" ? "solid #1E90FE 2px" : " solid #F1F4F6 1px"}`}}>
            <div onClick={()=>setMatricesState("retention_rate")} className="flex flex-col items-center gap-[10px] align-center" >
              <span className="text-[30px] md:text-[40px] leading-[48px] font-bold text-[#191919] tracking-tight text-center block">
                {metricsData?.customer_retention_rate}%
              </span>
              <p className="text-base font-medium leading-[160%] text-[#485868]">
                Customer Retention Rate
              </p>
              </div>
              </div>
              <div className="grid grid-cols-12 gap-y-2 gap-x-4 xl:block" >
                <div className="col-span-12 sm:col-span-6 p-3 md:py-[14px] md:px-5 border rounded-md flex items-center justify-between cursor-pointer bg-white mb-[10px]" onClick={()=>setMatricesState("beginning_active_accounts")} style={{border:`${metricsState === "beginning_active_accounts" ? "solid #1E90FE 2px" : " solid #F1F4F6 1px"}`}}>
                  <div className="flex items-center gap-[14px]" >
                    <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                      {metricsData?.beginning_active_accounts}
                    </span>
                    <div >
                      <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                        beginning active accounts
                      </h6>
                      <div className="flex items-center gap-1.5">
                        {metricsData?.beginning_active_accounts_change?.startsWith(
                          "-"
                        ) ? (
                          <RedChartSvg />
                        ) : (
                          <GreenChartSvg />
                        )}
                        <span
                          className={`text-sm font-bold leading-[180%] ${
                            metricsData?.beginning_active_accounts_change?.startsWith(
                              "-"
                            )
                              ? "text-[#EF2121]"
                              : "text-[#16CA7C]"
                          }`}
                        >
                          {metricsData?.beginning_active_accounts_change} YoY
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6 p-3 md:py-[14px] md:px-5 border rounded-md flex items-center justify-between cursor-pointer bg-white mb-[10px]" 
                style={{border:`${metricsState === "ending_active_accounts" ? "solid #1E90FE 2px" : " solid #F1F4F6 1px"}`}}
                onClick={()=>setMatricesState("ending_active_accounts")}>
                  <div className="flex items-center gap-[14px]">
                    <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]" >
                      {metricsData?.ending_active_accounts}
                    </span>
                    <div>
                      <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                        ending active accounts.
                      </h6>
                      <div className="flex items-center gap-1.5">
                        {metricsData?.ending_active_accounts_change?.startsWith(
                          "-"
                        ) ? (
                          <RedChartSvg />
                        ) : (
                          <GreenChartSvg />
                        )}
                        <span
                          className={`text-sm font-bold leading-[180%] ${
                            metricsData?.ending_active_accounts_change?.startsWith(
                              "-"
                            )
                              ? "text-[#EF2121]"
                              : "text-[#16CA7C]"
                          }`}
                        >
                          {metricsData?.ending_active_accounts_change} YoY
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6 p-3 md:py-[14px] md:px-5 border border-[#F1F4F6] rounded-md flex items-center justify-between cursor-pointer bg-white mb-[10px]"
                 style={{border:`${metricsState === "net_retention_rate" ? "solid #1E90FE 2px" : " solid #F1F4F6 1px"}`}}
                 onClick={()=>setMatricesState("net_retention_rate")}
                >
                  <div className="flex items-center gap-[14px]">
                    <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                      {metricsData?.new_active_accounts_added}
                    </span>
                    <div>
                      <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                        new active accounts added:
                      </h6>
                      <div className="flex items-center gap-1.5">
                        {metricsData?.new_active_accounts_added_change?.startsWith(
                          "-"
                        ) ? (
                          <RedChartSvg />
                        ) : (
                          <GreenChartSvg />
                        )}
                        <span
                          className={`text-sm font-bold leading-[180%] ${
                            metricsData?.new_active_accounts_added_change?.startsWith(
                              "-"
                            )
                              ? "text-[#EF2121]"
                              : "text-[#16CA7C]"
                          }`}
                        >
                          {metricsData?.new_active_accounts_added_change} YoY
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-span-12 sm:col-span-6 p-3 md:py-[14px] md:px-5 border border-[#F1F4F6] rounded-md flex items-center justify-between cursor-pointer bg-white mb-[10px]"
                  style={{border:`${metricsState === "account_cancelled" ? "solid #1E90FE 2px" : " solid #F1F4F6 1px"}`}}
                  onClick={()=>setMatricesState("account_cancelled")}
                >
                  <div className="flex items-center gap-[14px]">
                    <span className="number w-11 h-11 text-lg font-black leading-[180%] text-customGray flex items-center justify-center rounded-md bg-[#F1F4F6]">
                      {metricsData?.total_accounts_canceled}
                    </span>
                    <div>
                      <h6 className="text-sm font-medium leading-[160%] text-customGray capitalize">
                        total accounts canceled
                      </h6>
                      <div className="flex items-center gap-1.5">
                        {metricsData?.total_accounts_canceled_change?.startsWith(
                          "-"
                        ) ? (
                          <RedChartSvg />
                        ) : (
                          <GreenChartSvg />
                        )}
                        <span
                          className={`text-sm font-bold leading-[180%] ${
                            metricsData?.total_accounts_canceled_change?.startsWith(
                              "-"
                            )
                              ? "text-[#EF2121]"
                              : "text-[#16CA7C]"
                          }`}
                        >
                          {metricsData?.total_accounts_canceled_change} YoY
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 xl:col-span-8">
            {metricsState == "beginning_active_accounts" ? 
             <BarChartMedium /> : metricsState == "retention_rate" ? 
            <LineChart  chartData={revenueStatistics} /> : metricsState == "net_retention_rate" ?
            <LineChart  chartData={netRevenueStatistics} />  :  metricsState == "account_cancelled" ? <LineChart  chartData={accountCancelledStatistics} /> 
            :
            <BarChartThin/>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default MetricsData;
